var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolfHole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3796 99.6628C59.9623 102.058 62.3752 103.533 64.7747 102.953C67.1704 102.37 68.6453 99.9589 68.0645 97.5632C67.4799 95.1599 65.0689 93.6907 62.6694 94.2696C60.2756 94.8523 58.8008 97.2671 59.3796 99.6628Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5625 102.759V8.09277",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.564 11.3807C78.6092 4.78005 65.8685 18.5869 52.8125 11.7093V39.2808C64.6592 46.5272 79.7918 33.133 91.5315 40.0374",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.648 95.0982C81.8757 95.6121 78.3949 97.1539 78.4101 98.9535C78.4254 101.133 83.5741 102.862 89.9092 102.816C96.2442 102.771 101.366 100.965 101.353 98.7816C101.339 96.8043 97.0886 95.1957 91.5674 94.9492",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.325 77.1077C77.9441 76.2652 71.055 75.8086 63.8718 75.8086C30.9528 75.8086 4.27341 85.4487 4.27341 97.3393C4.27341 109.228 30.9528 118.87 63.8718 118.87C96.7869 118.87 123.472 109.228 123.472 97.3393C123.472 89.0614 110.534 81.8724 91.5675 78.2693",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfHole);
export default __webpack_public_path__ + "static/media/golf-hole.419e880fbac59dc035777a4233982563.svg";
export { ForwardRef as ReactComponent };